export function initRequestQuoteForm() {

    let data = {
        action: 'get_cart_items'
    };

    $('.submit-request-quote').on('click', (e) => {
            e.preventDefault();

            const rawFormData = $('.rq').serializeArray();

            if(rawFormData.every(item => item.value)) {

                const formData = rawFormData.reduce((acc, item) => { acc[item.name] = item.value; return acc; }, {});

                $('.submit-request-quote').prop('disabled', true);
                $('.submit-request-quote').html('Processing');

                $.post( wp_theme_info.ajaxurl, data, () => {
                } ).done((res) => {
                    const rawData = Object.values(res.data);
                    const orderData = rawData.map(item => ({product_id: item.product_id, quantity: item.quantity}));

                        $.post( wp_theme_info.ajaxurl, { 
                            action: 'create_quote_request',
                            first_name: formData.firstName,
                            last_name: formData.lastName,
                            company: formData.company,
                            email: formData.email,
                            order_data: JSON.stringify(orderData)
                        }, () => {
                        } ).done((res) => {
                            $('.submit-request-quote').html('Submit Request');
                            $('.rq__response--wrapper').html('Thank you for your request! We\'ll get in touch with you shortly with a quote for the selected items.');
                            $('.rq__response').addClass('rq__response--visible');
                            setTimeout(() => {
                                window.location.replace(`${location.protocol}//${location.host}/cart`)
                            }, 2000)
                            console.log( 'Quote request successfully created' );
                        } ).fail((err) => {
                            console.log( 'Could not create item' );
                            $('.submit-request-quote').html('Submit Request');
                            $('.submit-request-quote').prop('disabled', false);
                            $('.rq__response--wrapper').html('There was a problem sending your quote request. Please try again and contact us if the problem persists.');
                            $('.rq__response').addClass('rq__response--visible');
                        } );

                } ).fail((err) => {
                    console.log( 'Failed to get cart contents' );
                } );

        } else {

            $('.rq__response--wrapper').html('Please provide your name and email complete the quote request.');
            $('.rq__response').addClass('rq__response--visible');
            setTimeout(() => {
                $('.rq__response').removeClass('rq__response--visible');
            }, 5000)
        }
    })
}

